// extracted by mini-css-extract-plugin
export default {"cookieBar":"CookierBar_cookieBar__dp0DT"};